import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Layout from '../Layout/Layout';

interface LoadingDisplayProps {
    message?: string;
}

/**
 * Specialized component for displaying loading states
 * Provides consistent loading UI across the application
 */
export const LoadingDisplay: React.FC<LoadingDisplayProps> = ({ message }) => {
    const { t } = useTranslation();

    return (
        <Layout>
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
                <CircularProgress size={60} />
                <Typography variant="h6" style={{ marginLeft: 16 }}>
                    {message || t('loading_project_data') || 'Loading Project Data...'}
                </Typography>
            </Box>
        </Layout>
    );
};
